/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import ItemSelector from '@/components/batches/ItemSelector'
import MainTotalItems from '@/components/listings/MainTotalItems'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getAssetsByCompany } from '@/services/sams'
import { useSelectBatchItems } from '@/hooks/items/useSelectBatchItems'
import { setItemCustomProps } from './handlers'
import { Spinner } from '@chakra-ui/react'
import HorizontalCardWithAddRemoveOptions from '@/components/cards/HorizontalCardWithAddRemoveOptions'

const AvailableAssets = ({
  manageId
}) => {
  const {
    itemsResponse,
    onChangePage,
    page,
    loading,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getAssetsByCompany,
    fetchParams: { manageId }
  })
  const {
    isSelected,
    toggleSelection: toggleSelectionAsset,
    toggleSelectAllMode
  } = useSelectBatchItems()

  if (loading && !itemsResponse) return <div><Spinner size='lg' /></div>

  return (
    <section>
      <MainTotalItems
        className="mb-3"
        label="Available Assets"
        titleAs="h2"
        total={itemsResponse?.total}
      />
      <ItemSelector
        isSelected={isSelected}
        itemComponent={HorizontalCardWithAddRemoveOptions}
        items={itemsResponse?.assets}
        itemsLayout="cards"
        loading={loading}
        onChangePage={onChangePage}
        page={page}
        setItemCustomProps={setItemCustomProps}
        toggleSelectAllMode={toggleSelectAllMode}
        toggleSelection={toggleSelectionAsset}
        totalItems={itemsResponse?.total}
        totalPages={totalPages}
      />
    </section>
  )
}

export default AvailableAssets
